import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'shared-pickup-later',
    templateUrl: './pickup-later.shared.component.html',
    styleUrls: ['./pickup-later.shared.component.scss']
})
export class PickupLaterComponent implements OnInit {
    @Input() public labelType: OLO.Types.PICKUP_LABEL_TYPES = 'filter';
    @Input() public theme: OLO.Components.DropDown.IDropDownTheme = 'common';
    @Input() public defaultLabel: string = 'Later today';
    @Input() public isActive: boolean = false;
    @Input() public mode: OLO.Components.PICKUP_MODE = 'filter';
    @Input() public options: OLO.Components.DropDown.IDropDownOption[] = [];
    @Input() public dropdownWidth: OLO.Components.DROPDOWN_WIDTH = 'sm';
    @Input() public disabled: boolean = false;
    @Input() public isSchedule: boolean = false;

    @Input() public selected: OLO.Ordering.IPickupTime;
    @Output() public onDropdownToggle: EventEmitter<boolean> = new EventEmitter();
    @Output() public onDropdownSelected: EventEmitter<OLO.Components.DropDown.IDropDownOption> = new EventEmitter();

    ngOnInit(): void {
        if (this.isSchedule) {
            this.defaultLabel = 'Schedule';
        }
    }

    public dropdownToggle($event: boolean): void {
        this.onDropdownToggle.emit($event);
    }

    public dropdownSelected($event: OLO.Components.DropDown.IDropDownOption): void {
        this.onDropdownSelected.emit($event);
    }

    public get displayLabel(): string {
        if (!this.selected) {
            return this.isSchedule ? 'Schedule' : this.defaultLabel;
        } else {
            return this.selected.Name;
        }
    }
}
